import React from 'react';

import styles from './styles.module.scss';

export const NotFoundPage = () => {
  return (
    <div className={styles.root}>
      <div className={styles.notFoundPage}>Not found...</div>
    </div>
  );
};
